import * as React from "react"
import PropTypes from "prop-types"

// Shards React Component
import { Nav, NavItem, NavLink } from "shards-react"

import { Tooltip } from "react-bootstrap"

// Mobile Menus
import MobileView from "../common/mobileView"

// Import data
import articles from "../data/supportArticles.json"
import mobileMenuAppItems from "../data/menus/mobileMenuAppItems"

import { routify } from "../js/routify"

const renderTooltip = props => (
  <Tooltip id="button-tooltip" {...props}>
    {props.description}
  </Tooltip>
)

const SupportArticleItem = props => (
  <li className="pt-2" id={props.id}>
    <a className="text-primary" href={props.href} target="_blank">
      {props.title}
    </a>
  </li>
)

const AppMenuItem = props => (
  <NavItem key={props.id}>
    <NavLink active href={props.href}>
      <div style={{ display: "block" }}>
        <div dangerouslySetInnerHTML={{ __html: props.icon }} />
        <div className="text-dark" style={{ paddingTop: "1rem" }}>
          {props.title}
        </div>
      </div>
    </NavLink>
  </NavItem>
)

// Mobile App-like Menu/ Navigator
const AppMenu = props => (
  <React.Fragment>
    <hr />
    <Nav fill>
      {mobileMenuAppItems.map(item => (
        <AppMenuItem
          id={item.id}
          title={item.title}
          icon={item.icon}
          href={routify(props.countryCode || "JM", item.href)}
        />
      ))}
    </Nav>
  </React.Fragment>
)

// Support Menu
const SupportMenu = () => (
  <React.Fragment>
    <hr />
    <h4>Need help?</h4>
    <p>
      Read our support articles or speak with a customer service representative
    </p>

    <br />
    <ul className="ul">
      {articles.map(article => (
        <SupportArticleItem
          id={article.id}
          title={article.title}
          description={article.description}
          href={article.href}
        />
      ))}
    </ul>
  </React.Fragment>
)

class MainMobileMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <MobileView>
        <AppMenu
          countryCode={this.props.countryCode || "JM"}
          routes={this.props.routes}
        />
        <SupportMenu />
      </MobileView>
    )
  }
}

MainMobileMenu.propTypes = {
  siteTitle: PropTypes.string
}

MainMobileMenu.defaultProps = {
  siteTitle: ``
}

export default MainMobileMenu
